import gsap from "@traina/gsap";
import {ScrollTrigger} from "@traina/gsap/ScrollTrigger";
import {ScrollSmoother} from "@traina/gsap/ScrollSmoother";
import {SplitText} from "@traina/gsap/SplitText";
import {Flip} from "@traina/gsap/Flip";


gsap.config({
    nullTargetWarn:false
})

let smoother;

export const setSmoother = (val) => smoother = val;

let isForcingScrollUpdate = false;

export function forceScrollSmootherUpdate({ preserveScroll = true } = {}){
    if(isForcingScrollUpdate) return;

    isForcingScrollUpdate = true;

    const current = preserveScroll ? scrollPosition() : null;

    // Defer to the next frame so layout settles first (especially during resizes).
    requestAnimationFrame(() => {
        try {
            if(smoother && typeof smoother.refresh === 'function'){
                smoother.refresh();
            }

            ScrollTrigger.refresh(true);

            if(preserveScroll && current != null){
                if(smoother){
                    smoother.scrollTop(current);
                }
                else {
                    window.scrollTo(0, current);
                }
            }

            ScrollTrigger.update();
        }
        finally {
            isForcingScrollUpdate = false;
        }
    });
}

export function addScrollSmootherEffects(target, config){
    if(smoother){
        smoother.effects(target, config);
    }
}

export function scrollToTop() {
    if( smoother ) {
        ScrollSmoother.get().scrollTop(0);
        window.scrollTop = 0;
        forceScrollSmootherUpdate({ preserveScroll: false });

    } else {
        window.scrollTo(0,0);
    }
}

const scrollPosition = () => {
    return smoother ? smoother.scrollTop() : window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
}

export {gsap,ScrollTrigger,ScrollSmoother, SplitText, smoother, Flip, scrollPosition};